// todo: factory address
export const FACTORY_ADDRESS = process.env.REACT_APP_SWAP_FACTORY_ADDRESS;

export const BUNDLE_ID = '1'

export const timeframeOptions = {
  WEEK: '1 week',
  MONTH: '1 month',
  // THREE_MONTHS: '3 months',
  // YEAR: '1 year',
  ALL_TIME: 'All time'
}

// token list urls to fetch tokens from - use for warnings on tokens and pairs
export const SUPPORTED_LIST_URLS__NO_ENS = [
  // todo: token list
  process.env.REACT_APP_DEFAULT_TOKEN_LIST
]

// hide from overview list
export const OVERVIEW_TOKEN_BLACKLIST = [
  '0x495c7f3a713870f68f8b418b355c085dfdc412c3',
  '0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea',
  '0xe31debd7abff90b06bca21010dd860d8701fd901',
  '0xfc989fbb6b3024de5ca0144dc23c18a063942ac1'
]

// pair blacklist
export const PAIR_BLACKLIST = ['0xb6a741f37d6e455ebcc9f17e2c16d0586c3f57a5']

/**
 * For tokens that cause erros on fee calculations
 */
export const FEE_WARNING_TOKENS = ['0xd46ba6d942050d489dbd938a2c909a5d5039a161']

// todo: ether scan prefix
export const ETHER_SCAN_PREFIX = process.env.REACT_APP_SCAN_EXPLORER_URL;

export const NATIVE_TOKEN_SYMBOL = process.env.REACT_APP_NATIVE_TOKEN_SYMBOL || 'ETH';
export const WRAPPED_NATIVE_TOKEN_SYMBOL = `W${NATIVE_TOKEN_SYMBOL}`;
